<app-pageheader>
  <form-edit-button routerLink="edit">Edit</form-edit-button>
</app-pageheader>

<section class="workflow-viewer">
  @if (isLoading) {
    <div class="loading-indicator">
      <span class="loader"></span>
      <p>Loading workflow…</p>
    </div>
  }

  @if (!isLoading) {
    <app-workflow-editor
      [workflow]="workflow"
      [readonly]="true">
    </app-workflow-editor>
  }
</section>
